// hooks/useConfirm.ts
import { useDispatch } from 'react-redux';
import { showConfirmModal } from '../store/slices/confirmModal/confirmModalSlice';
import { registerConfirmCallback } from '../features/modals/confirmCallbackRegistry';

export interface ConfirmOptions {
  title: string;
  message: string;
  icon?: 'warning' | 'success' | 'error' | 'info';
  confirmText?: string;
  cancelText?: string;
  onConfirm: (args?: any) => void;
  confirmArgs?: any;
}

const useConfirm = () => {
  const dispatch = useDispatch();

  return (options: ConfirmOptions) => {
    const { onConfirm, ...serializableOptions } = options;
    registerConfirmCallback(onConfirm);
    dispatch(showConfirmModal(serializableOptions));
  };
};

export default useConfirm;
